<template>
  <div class="md:text-2xl text-gray-900 sm:truncate">
    <slot />
  </div>
</template>
